// extracted by mini-css-extract-plugin
export default {"grid":"Gallery_grid__9-7t1"};